import { atom } from 'recoil'
import { Unidade } from '@/domain/models'

export const currentUnitState = atom({
  key: 'currentUnitState',
  default: null as unknown as Unidade
})
